import axios from 'axios'
import {msgInfo,msgWarning,msgError} from '../common'
import router from '../router/index'
import {url_glass} from '../common'

const service = axios.create({
  baseURL:  url_glass,
  timeout: 30000, // request timeout  设置请求超时时间
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
  "Content-Type": "application/json;charset=utf-8",
}
})
//请求拦截器
service.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('token')) {
      config.headers.Authorization = sessionStorage.getItem('token')
    }
    return config;
},
  error => {
    // 对请求错误做些什么，自己定义
  msgError('请求超时')
    return Promise.reject(error);
  })

//响应拦截器
service.interceptors.response.use(res => {
    if (res.status === 401) {
      console.log(1111)
      router.replace({
        name:'login'
      })
    }
    if (res.data.message){
      msgInfo(res.data.message)
    }
    return res
  },
  error => {
  console.log(error.response)
    if (error.response.status === 401) {
    msgWarning('请求失败，请稍后重试！')
    sessionStorage.clear()
    router.replace({
      name:'login'
    })
      msgWarning('请求失败，请稍后重试！')
    return Promise.reject('error');
  }
    msgWarning('请求失败，请稍后重试！')
    return Promise.reject(error);
}

)
export default service



// WEBPACK FOOTER //
// ./src/network/glassRequest.js